import FlowViewComponent from './flow-view-component';

export default FlowViewComponent;
